import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '0',
    marginBottom: '0',
  },
  tabsRoot: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  tabContent: {
    padding: theme.spacing(2),
  },
  paper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden', // Prevent parent overflow
  },
  calendarPaper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    backgroundColor: '#ccc',
    // height: '28vh',
    // marginBottom: 5
  },
  crewPaper: {
    color: theme.palette.text.secondary,
    backgroundColor: '#eee',
    width: '100%',
    paddingBottom: 20,
    // marginBottom: 80,
    // height: '50vh',
  },
  crewSearchArea: {
    margin: 5,
    padding: 5
  },
  unassignedJobsPaper: {
    color: theme.palette.text.secondary,
    backgroundColor: '#eee',
    padding: 5,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
    },
    '-ms-overflow-style': '-ms-autohiding-scrollbar',
    'scrollbar-width': 'thin',
  },
  unassignedJobsHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    padding: 5,
    margin: 5,
    alignItems: 'center'
  },
  mapContainer: {
    position: 'relative',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  map: {
    flexGrow: 1,
    minHeight: '50%',
    width: '100%',
  },
  selectedCrewContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#fff',
    zIndex: 1,
    boxShadow: theme.shadows[4],
    height: '45vh',
    transition: 'height 0.3s ease-in-out',
  },
  mapOverlayActionArea: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
    top: 30,
    left: 250,
  },
  toggleButton: {
    position: 'absolute',
    top: -28,
    right: theme.spacing(2),
    zIndex: 3,
  },
  unassignedJobItem: {
    border: '2px solid #000',
    margin: 5,
    padding: 5,
    backgroundColor: '#fff',
    borderRadius: 12
  },
  activeJobItem: {
    border: '3px solid red',
    margin: 5,
    padding: 5,
    backgroundColor: '#ddd',
    borderRadius: 12
  },
  crewList: {
    backgroundColor: '#eee',
    margin: 3,
    padding: 5,
    flex: 1,
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
    },
    '-ms-overflow-style': '-ms-autohiding-scrollbar',
    'scrollbar-width': 'thin',
  },
  crewDetailsTopLine: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  crewDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  crewBlockColor: {
    width: '80px',
    height: '80px',
    borderRadius: 5
  },
  dateArea: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'space-evenly'
  },
  crewsStopsContainer: {
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: '200px',
    padding: 5,
    width: '100%'
  },
  nearestSiteItemContainerOLD: {
    border: '1px solid #ddd',
    borderRadius: 5,
    marginBottom: 5,
    padding: 10,
    backgroundColor: '#fff',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  nearestSiteItemContainer: {
    display: 'flex',
    alignItems: 'stretch',
    marginBottom: theme.spacing(2),
    backgroundColor: '#fff',
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[1],
    overflow: 'hidden',
    cursor: 'pointer',
  },
  colorBar: {
    width: 14,
  },
  contentContainer: {
    flex: 1,
    display: 'flex',
    padding: theme.spacing(2),
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  smallColumn: {
    flex: '0 0 20%',
    marginRight: theme.spacing(2),
  },
  largeColumn: {
    flex: 1,
  },
  infoItem: {
    marginBottom: theme.spacing(1),
  },
  infoItemClickable: {
    marginBottom: theme.spacing(1),
    cursor: 'pointer'
  },
  infoValue: {
    fontSize: '1.1rem',
    fontWeight: 700,
    color: theme.palette.text.secondary,
  },
  infoLabel: {
    fontSize: '0.65rem',
    fontWeight: 400,
    textTransform: 'uppercase',
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5),
  },
  siteListContainer: {
    overflow: 'auto',
    maxHeight: '50vh',
    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
    },
    '-ms-overflow-style': '-ms-autohiding-scrollbar',
    'scrollbar-width': 'thin',
  },
  activeMarkerContainer: {
    backgroundColor: '#fff',
    padding: 5,
    margin: 10,
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignContent: 'center',
    margin: 5,
    padding: 5
  },
  flexRowCentered: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignContent: 'center',
    margin: 5,
    padding: 5
  },
  sortButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1),
  },
  paperRoot: {
    backgroundColor: '#fff',
    padding: 0,
    width: '100%',
    margin: 0
  },
  tabPanel: {
    padding: 0,
    margin: 0,
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    '& .MuiBox-root': {
      padding: '0 !important',
      height: '100%',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
    },
  },
  unassignJobsContainer: {
    padding: 10,
    flex: 1,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  viewToggleContainer: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    zIndex: 1000,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0.5),
  },
  timelineWrapper: {
    height: 'calc(100vh - 120px)', // Increased height to use more screen space
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'hidden',
  },
  timelineScrollContainer: {
    flex: 1,
    position: 'relative',
    overflow: 'hidden',
    // Prevent Mac elastic scrolling/bounce
    '-webkit-overflow-scrolling': 'touch',
    'overscroll-behavior': 'contain',
  },
  timelineContent: {
    height: '100%',
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
  },
  fullscreenTimeline: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'hidden',
  },
  timeline: {
    height: '100%',
    flex: 1,
    '& .rct-horizontal-lines': {
      borderTop: `1px solid ${theme.palette.divider}`,
    },
    '& .rct-vertical-lines': {
      borderLeft: `1px solid ${theme.palette.divider}`,
    },
    '& .rct-today': {
      backgroundColor: theme.palette.error.light,
      width: '2px !important',
    },
    '& .rct-header': {
      position: 'sticky',
      top: 0,
      zIndex: 10,
      backgroundColor: theme.palette.background.paper,
    },
    '& .rct-header-root': {
      backgroundColor: theme.palette.background.paper,
      borderBottom: `2px solid ${theme.palette.divider}`,
    },
    '& .rct-sidebar': {
      backgroundColor: theme.palette.background.paper,
    },
    '& .rct-sidebar-header': {
      position: 'sticky',
      top: 0,
      zIndex: 11,
      backgroundColor: theme.palette.background.paper,
      borderBottom: `2px solid ${theme.palette.divider}`,
    },
    '& .rct-scroll': {
      overflow: 'auto !important', // Ensure timeline can scroll vertically
    },
    '& .rct-canvas': {
      minHeight: 'auto !important', // Allow canvas to grow with content
    },
  },
  timelineContainer: {
    position: 'relative',
    height: 'calc(100% - 160px)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  fullscreenButton: {
    marginLeft: theme.spacing(1),
  },
  fullscreenContainer: {
    position: 'relative',
    height: '100vh',
    backgroundColor: theme.palette.background.default,
  },
  fullscreenCloseButton: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    zIndex: 1000,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 1)',
    },
  },
  timelineControls: {
    backgroundColor: '#fff',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    margin: theme.spacing(2),
    marginBottom: theme.spacing(1),
    display: 'flex',
    gap: theme.spacing(0.5),
    boxShadow: theme.shadows[3],
    alignItems: 'center',
    flexShrink: 0,
  },
  timelineDateDisplay: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginRight: theme.spacing(2),
    padding: theme.spacing(0.5, 1),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    borderRadius: theme.shape.borderRadius,
    fontWeight: 'bold',
  },
  timelineNavigationButtons: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    marginRight: theme.spacing(1),
    borderRight: `1px solid ${theme.palette.divider}`,
    paddingRight: theme.spacing(1),
  },
  timelineCrewSidebar: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
    borderRight: `2px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    height: '100%',
    position: 'sticky',
    left: 0,
    zIndex: 5,
  },
  timelineCrewInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  timelineCrewName: {
    fontWeight: 'bold',
    fontSize: '0.9rem',
  },
  timelineCrewStats: {
    display: 'flex',
    gap: theme.spacing(0.5),
  },
  timelineNoJobsMessage: {
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '400px',
    flexDirection: 'column'
  },
  weeklySummaryPanel: {
    backgroundColor: '#f5f5f5',
    padding: theme.spacing(2),
    // margin: theme.spacing(0, 0.5),
    border: '1px solid #ccc',
    borderRadius: theme.shape.borderRadius,
    flex: '0 0 auto', // Don't grow or shrink
    minHeight: '150px',
    maxHeight: '350px',
    overflow: 'auto',
    marginTop: 2,
    marginBottom: 2
  },
  summaryRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(0.5, 0),
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  summaryMetric: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  tabsRootSidebar: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  paperRoot: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    height: '100%',
  },
}));

export const mapContainerStyle = {
  width: '100%',
  height: '100%',
};
